












































































































import Vue from "vue";

//Component
import DeleteTemplateDialog from "../CaosConfigurationTemplate/DeleteTemplateDialog.vue";
import ActualConfigurationDialog from "../SecurityManagement/ActualConfigurationDialog.vue";
import BulkImportTemplateWizard from "./BulkImportTemplateWizard.vue";

//Model
import { dataTableItemsPerPage, MODULE_COLORS } from "@/utility/Constants";
import { TemplateContentEnumToString } from "@/model/data/enums/TemplateContentEnum";
import { ApiGenericResponse } from "@/model/communication/ApiGenericResponse";
import { DeleteTemplateCommand } from "@/model/communication/security/DeleteTemplateCommand";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { RollProfile } from "@/model/data/security/InstallationStocksConfiguration";

export default Vue.extend({
    props: {
        loading: { required: true, type: Boolean },
        paginatedTotalItems: Number,
        configurationTemplates: { required: true, type: Array },
        reqData: Object,
    },
    components: { DeleteTemplateDialog, ActualConfigurationDialog, BulkImportTemplateWizard },
    data() {
        return {
            MODULE_COLORS,
            RollProfile,
            headers: [
                {
                    text: "",
                    value: "templateIcon",
                    sortable: false,
                },
                {
                    text: this.$t("caosTemplate.templateName"),
                    value: "name",
                },
                {
                    text: this.$t("caosTemplate.templateContent"),
                    value: "templateContent",
                    align: "center",
                },
                {
                    text: this.$t("common.actions"),
                    value: "actions",
                    align: "center",
                    sortable: false,
                    width: "150px",
                },
            ],
            dataTableItemsPerPage,
            options: {},
            currentTemplate: null,
            currentTemplateName: "",
            showDeleteDialog: false,
            deleteLoading: false,
            showInfoDialog: false,
            showForceTemplateDialog: false,
            search: "",
        };
    },
    methods: {
        TemplateContentEnumToString,
        backToTheFirst() {
            if (this.options.page != 1) {
                this.ignoreOptionsChanges = false;
                this.options.page = 1;
                console.log("backToTheFirst, this.options: ", this.options);
            }
        },
        openInfoDialog(item) {
            this.currentTemplate = item;
            this.showInfoDialog = true;
        },
        openDeleteDialog(item) {
            this.currentTemplate = item;
            this.currentTemplateName = item.name;
            this.showDeleteDialog = true;
        },
        openForceTemplateWizard(item) {
            this.currentTemplate = item;
            this.showForceTemplateDialog = true;
        },
        async deleteTemplate() {
            try {
                this.deleteLoading = true;
                let response: ApiGenericResponse = await new DeleteTemplateCommand(this.currentTemplate.id).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.$emit("reload");
                    this.showDeleteDialog = false;
                }
            } catch (e) {
                console.log("Something went wrong sending DeleteTemplate request ", e);
            }
            this.deleteLoading = false;
        },
    },
});
